import { DocumentNode, OperationVariables, QueryOptions, useApolloClient } from '@apollo/client';
import React, { useState } from 'react';

export function usePromiseQuery<
  TData = any,
  TVariables extends OperationVariables = OperationVariables
>(query: DocumentNode, options?: Partial<QueryOptions<TVariables, TData>>) {
  const [prevVariables, setPrevVariables] = useState<TVariables>();
  const client = useApolloClient();
  return React.useCallback(
    (variables: TVariables) => {
      // We save a copy of the the sum of variables to avoid having to pass all variables
      // on subsequent calls
      setPrevVariables((prev) => ({ ...prev, ...variables }));
      return client.query<TData, TVariables>({
        query: query,
        variables: { ...prevVariables, ...variables }, // Due to setState being async we do the same operation here
        fetchPolicy: 'network-only',
        ...options,
      });
    },
    [client],
  );
}
